import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=52788cac"
import script from "./CarouselCard.vue?vue&type=script&lang=ts"
export * from "./CarouselCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports